import React, { useState } from 'react'
import { TextInput } from '../Korbantech/components/Inputs/TextInput'
import { Label } from '../Korbantech/components/Label'
import { AdminUser } from '../types/AdminUser'
import { CheckItem } from './CheckItem'


export const AdminForm = ({user}:Props) => {

    const [isAdmin,setIsAdmin] = useState<boolean>(user?.is_super_admin? user.is_super_admin : false)

    return(
        <div>
            <Label>
                Nome
                <TextInput name={"name"} defaultValue={user?.name ? user.name : ''} />
            </Label>
            <Label>
                Email
                <TextInput name={"email"} defaultValue={user?.email ? user.email : ""} />
            </Label>
            <Label>
                Admin
                <CheckItem type='radio' name={"is_super_admin"} value={isAdmin ? 1 : 0} onClick={()=>setIsAdmin(prev=>prev? false : true )} defaultChecked={isAdmin} />
            </Label>
            <Label>
                Senha
                <TextInput type={"password"} name="password" />
            </Label>
            <Label>
               Confirmar Senha
                <TextInput type={"password"} name="password_confirmation" />
            </Label>
        </div>
    )
}

interface Props {
    user?:AdminUser
}